import React from 'react';
import './Pokerwatch_new.css';
import DataTable from '../common/Table/index';
import Grid from '@material-ui/core/Grid';
import DownloadHandHistory from '../../components/DownloadHandHistory/DownloadHandHistory';
import {saveActivity} from '../../common/commonService';
import $ from 'jquery';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import { InputDatePicker } from 'mygame-components';
import CustomisedDialog from './CustomisedDialog';
import ReportCardIcon from '../../img/reportcard.png';
import VisibilitySensor from 'react-visibility-sensor';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import CurrentFilter from './CurrentFilter'

const HeaderDetails = props => {
    const { playerData, NumberFormatter,filterStatusObj } = props;
    //console.log('props', props);
    return (
        <div className='container' >
            <Grid container spacing={24} style={{
                marginTop: '-5px',
                width: '125rem',
                paddingTop: '15px',
            }}>
                <Grid item xs={8}>
                    <Grid container spacing={24} >

                        <Grid item xs style={{ marginTop: '0px', padding: '0px' }}>
                            <span className="pokerwatch-admin-stable-name">{playerData !== undefined ? playerData.playerName : 'NA'}</span>
                            {playerData.statsVisible ? <i className="fa fa-chart-bar fa-lg chart-bar-icon" style={{ width: '0px' }}></i> : ''}
                        </Grid>
                    </Grid>
                    <Grid container spacing={24} style={{ marginTop: '8px' }}>
                        <Grid item xs>
                            <div className="pokerwatch-team-stats-details">
                                <span>Games Played: {playerData !== undefined ? NumberFormatter(playerData.noOfGames) : 0}</span>
                                <span>
                                    P&L: {(playerData !== undefined && playerData.profitOrLoss > 0) ? "+" : ""}{playerData !== undefined ? NumberFormatter(playerData.profitOrLoss) : 0}
                                </span>
                                <span>Rake: {playerData !== undefined ? NumberFormatter(playerData.totalRake) : 0}</span>
                                <span>Win Rate: {playerData !== undefined ? NumberFormatter(playerData.winRate) : 'winRate'} </span>
                                <span>EV: {playerData !== undefined ? NumberFormatter(playerData.ev) : 'ev'}</span>
                                <span>EV Diff: {playerData !== undefined ? NumberFormatter(playerData.evDiff) : 'evDiff'}</span>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <StatsDetails {...props} ></StatsDetails>
                </Grid>
                <CurrentFilter filterStatusObj={filterStatusObj}/>
            </Grid>
        </div>
    )
}
const AssignPlayerToTeam = props => {
    const { subTeam, currentSubTeamObj, updatedSubTeam, handleAssignTeam } = props;
    //console.log('currentSubTeamObj',currentSubTeamObj)
    //console.log('updatedSubTeam',updatedSubTeam)
    let options = subTeam.map((data) => <option key={data.teamName ? data.teamName : data.name}
        value={data.teamName ? data.teamName : data.name}>
        {data.teamName ? data.teamName : data.name}
    </option>
    );
    return <div className="pokerwatch-dialog-common">
        <select className="form-control2 pokerwatch-team-filet-select " style={{ height: '36px', border: '1px solid #D1D1D1', borderRadius: '4px' }} onChange={handleAssignTeam} value={updatedSubTeam ? updatedSubTeam : currentSubTeamObj.teamName ? currentSubTeamObj.teamName : 'select'}>
            <option value='select'>Select Team</option>
            {options}
        </select>
    </div>

}
const CustomisedDiv = (props) => {
    const {dialogContent,addPlayerToList} = props
    const {isDialogOpen,title,dataType,cancelDialog, actionPerform,errorMessage,isError,createButtonLable,createButtonStyleName} =dialogContent;
    if(!isDialogOpen){
        return ''
    }
    return <div className="customised-div">
          <span className="pw-filter-mobile-setting-span"> {title }</span> <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={e => cancelDialog(e,  {dataType})}></i>
          {dialogContent.dataType === 'deletePlayer' ? <p className="pokerwatch-dialog-common">Would you like to remove selected player(s) from the team?</p> : dialogContent.dataType === 'enableStats' ?
                    <p className="pokerwatch-dialog-common">Would you like to make visible P&L, Rake and EV for the selected players ?</p> : dialogContent.dataType === 'disableStats' ?
                        <p className="pokerwatch-dialog-common">Would you like to hide P&L, Rake and EV for the selected players ?</p> 
                        :dialogContent.dataType === 'assingPlayer' ?
                        <AssignPlayerToTeam {...props}></AssignPlayerToTeam>: ''
                }
<span style={{color:'red'}}>{errorMessage} </span>
        <div className="poker-watch-create-team-buttons-div">
          <button className="poker-watch-cancel-team-button"data-e2e="team-cancel" onClick={e => cancelDialog(e, {dataType})} >Cancel</button>
          <button className={createButtonStyleName?createButtonStyleName:"poker-watch-create-team-button-not-active"} data-e2e="team-cancel" onClick={isError?'':actionPerform}>{createButtonLable?createButtonLable:'create'}</button>
        </div>
    </div>
}
const StatsDetails = props => {
    //console.log('statsDetails', props);
    let { enableComponent, filterEnable,  openDialogBox, dialogContent,  reportCard, statsUpdate, bussinessOwnerStatus, isCoach } = props;

    return (
        // style={deletePlyrData && deletePlyrData.length > 0 ? { paddingLeft: '28rem' } : { paddingLeft: '48rem' }}
        <div className="pokerwatch-player-icon" style={{ paddingLeft: bussinessOwnerStatus && !isCoach ? '14rem' : '18rem' }} >

            {bussinessOwnerStatus && !isCoach ? <i className="fa fa-trash fa-lg" onClick={e => openDialogBox('deletePlayer')}  ></i> : ''}
            <i className="fa fa-lg fa-download" 
            data-toggle="modal" data-target="#downloadModal"
                onClick={(e)=>{
                    e.preventDefault();
                    props.openPopUp();
                    props.trackDownloadPlayerHandHistory(props.playerData ? props.playerData.playerName : "N/A");
                    localStorage.setItem("accountNames",props.playerData ? JSON.stringify([props.playerData.playerName]) :JSON.stringify([]));
                }}
            ></i>
            <i className="report-card-button" onClick={reportCard}> <img src={ReportCardIcon} alt="ReportCard" height='18px' /></i>
            <i className="fa fa-chart-bar fa-lg chart-bar-icon" onClick={() => enableComponent('statsUpdate',true)}></i>
            {statsUpdate ? <div className="stats-update-div" style={{ marginLeft: '6rem' }} >

                <button className="stats-button-on-off" onClick={(e) => openDialogBox('enableStats', 'statsUpdate')} style={{ marginBottom: '5px' }}>Stats On</button>

                <button className="stats-button-on-off" onClick={(e) => openDialogBox('disableStats', 'statsUpdate')}>Stats Off</button>

            </div> : ''}
            {filterEnable ? <i className="fa fa-lg fa-times" style={{ marginRight: '0px', width: '10px', marginLeft: '-20px' }} onClick={() => enableComponent('filterEnable')}></i>
                : <i className="fa fa-lg fa-filter" style={{ marginRight: '0px', width: '10px', marginLeft: '-20px' }} onClick={() => enableComponent('filterEnable')}></i>}
            {dialogContent && dialogContent.isDialogOpen && <CustomisedDialog {...dialogContent} >
                {dialogContent.dataType === 'deletePlayer' ? <p className="pokerwatch-dialog-common">Would you like to remove selected player(s) from the team?</p> : 
                dialogContent.dataType === 'enableStats' ?
                    <p className="pokerwatch-dialog-common">Would you like to make visible P&L, Rake and EV for the selected players ?</p> : dialogContent.dataType === 'disableStats' ?
                        <p className="pokerwatch-dialog-common">Would you like to hide P&L, Rake and EV for the selected players ?</p> : ''
                }
            </CustomisedDialog>}
        </div>)

}
const GameType = (props) => {
    const {handleGameType,gameType} = props;
    return  <div>
        <label htmlFor="select1" className="period_select_lable" >GAME TYPE</label>
                <select className="form-control2 pokerwatch-team-filet-select" data-e2e="game-type" onChange={e => handleGameType(e, 'player')} value={gameType}>
                    <option value="cash">Cash Games</option>
                    <option value="tournament">MTT</option>
                    <option value="Spin">Spins</option>
                </select>
    </div>
}
const FromDate = (props) => {
    const {dateError,downloadFrom,showFromDatePicker,selectedFromDate,handleChange,handleSave,updatePosition} = props
    return <div>
         <div className="dp_date_picker_group" id="pw_dp_date_picker_group1" data-toggle="modal"
            data-target="#pWdpFromDateTimePicker">
        <div className="dp_lable">
    FROM:<span className="date-error">{dateError && dateError.fromDate ? dateError.fromDate : ''}</span>
</div>
<div className="pw_team_selector_dropdown" onClick={()=>updatePosition(true)} >
    <span className="pw_team_datepicker_text" data-e2e="from-date">

        {(showFromDatePicker) ? moment(downloadFrom).format("DD/MM/YYYY - hh:mmA") : <spam>DD/MM/YYYY{<span style={{ marginLeft: "5px", marginRight: "5px" }}>&#8212;</span>}HH/MM</spam>}
    </span>
</div>
</div>
<InputDatePicker modalId="pWdpFromDateTimePicker" selectedDate={selectedFromDate} 
    handleChange={(data) => { handleChange(data, "selectedFromDate") }}
    handleSave={() => {
        handleSave("downloadFrom", "showFromDatePicker", "player");
        $('#pw_dp_date_picker_group1').click();
        updatePosition(false);
    }}
/>
    </div>
}
const ToDate = (props) => {
    const {dateError,selectTo,showToDatePicker,selectedToDate,handleChange,handleSave,updatePosition} = props
    return <div><div className="dp_date_picker_group" id="pw_dp_date_picker_group2" data-toggle="modal"
    data-target="#pWdpToDateTimePicker" >
    <div className="dp_lable">
        TO:<span className="date-error">{dateError && dateError.toDate ? dateError.toDate : ''}</span>
    </div>
    <div className="pw_team_selector_dropdown"  onClick={()=>updatePosition(true)} >
        <span className="pw_team_datepicker_text" data-e2e="to-date" >
            {(showToDatePicker) ? moment(selectTo).format("DD/MM/YYYY - hh:mmA") : <spam>DD/MM/YYYY{<span style={{ marginLeft: "5px", marginRight: "5px" }}>&#8212;</span>}HH/MM</spam>}
        </span>

    </div>
</div>
<InputDatePicker
    modalId="pWdpToDateTimePicker"
    selectedDate={selectedToDate}
    handleChange={(data) => { handleChange(data, "selectedToDate") }}
    handleSave={() => {
        handleSave("selectTo", 'showToDatePicker', 'player');
        $('#pw_dp_date_picker_group2').click();
        updatePosition(false);
    }}
/>
        </div>
}
const FilterGrid = props => {
    //console.log('FilteGrid', props);
    const {position} = props
    return (<MediaQuery minWidth={1025}>
        {(matches) => {
            if (matches) {
                return  <div className="pokerwatch-player-filter container" style={{position:position?'inherit':'fixed',top:'5rem',zIndex:'160', width: 'auto', marginRight: '20px', marginLeft: '0px', paddingLeft:'12px' }}>
                <Grid container spacing={24} style={{  background: '#FFFFFF',width:'1209px',paddingLeft:'0px', 
                borderBottom: '1px solid #E8E8E8', borderTop: '1px solid #E8E8E8'}}>
                    <Grid item xs={6} sm={3}>
                        <GameType {...props}></GameType>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <FromDate {...props}></FromDate>
                                   </Grid>
                    <Grid item xs={6} sm={3}>
                       <ToDate {...props}></ToDate>
        
                    </Grid>
        
                </Grid>
        
            </div>
             }
            else {
                const {enableComponent,showResults} = props;
                   
                return <Grid container spacing={24}>
                    <Grid item xs={12}><span className="pw-filter-mobile-setting-span"> Filters</span>
                        <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={() => enableComponent('playerMenuEnable',false,true)}></i>
                    </Grid>  
                    <Grid item xs={12}> <GameType {...props} /> </Grid>
                    <Grid item xs={12}> <FromDate {...props} /> </Grid>
                    <Grid item xs={12}> <ToDate {...props} /> </Grid>
                    {showResults &&  <Grid item xs={12} ><div className='show-results-div'><button className='show-results-mobile' onClick={() => enableComponent('moreEnable',false,true)}>SHOW RESULTS</button> </div></Grid>}
                </Grid>
            }
            }}</MediaQuery>
   )
}
const MobileHeaderView = props => {
    const { playerData, NumberFormatter, playerInfo, enableComponent, routeChange } = props;
    return <nav className="navbar-fixed-top fixed-top-2" style={{paddingLeft:'1.2rem',minHeight:'55px',height:'55px'}}>
        <div className="container mygame-header-container-div" style={{paddingTop:window.innerWidth>=768 ?'6px':'12.5px'}}>
        <div className="go-back-arrow-div" style={{marginTop:window.innerWidth>=768 ?'8px':'3px',marginLeft:'-7px'}}>
            <i className="fa fa-arrow-left " data-e2e="go-back-left-arrow" onClick={() => routeChange('/pokerwatchteam')} ></i></div>
            <span className='pokerwatch-team-header-row pokerwatch-team-header-row-team-name' style={{ fontSize: '16px' }}>{playerData ? playerData.playerName : 'NA'}</span>
            {playerData.statsVisible ? <i className="fa fa-lg fa-chart-bar chart-bar-icon" style={{ marginLeft:'10px',width: '0px' }}></i> : ''} <button className='pw-info-mobile' style={{paddingLeft:'8px',marginLeft:playerData.statsVisible?'-6px':'0px'}} onClick={() => enableComponent('playerInfo')} ><i className="fa fa-lg fa-info-circle"></i></button>
            {playerInfo && window.innerWidth <= 768 ? <div className="dropdown-content-game-detail-mobile">
                <span>Games Played: {playerData !== undefined ? NumberFormatter(playerData.noOfGames) : 0}</span><br></br>
                <span>
                    P&L: {(playerData !== undefined && playerData.profitOrLoss > 0) ? "+" : ""}{playerData !== undefined ? NumberFormatter(playerData.profitOrLoss) : 0}
                </span><br></br>
                <span>Rake: {playerData !== undefined ? NumberFormatter(playerData.totalRake) : 0}</span><br></br>
                <span>Win Rate:  {playerData !== undefined ? NumberFormatter(playerData.winRate) : 'winRate'}</span><br></br>
                <span>EV: {playerData !== undefined ? NumberFormatter(playerData.ev) : 'ev'}</span><br></br>
                <span>EV Diff: {playerData !== undefined ? NumberFormatter(playerData.evDiff) : 'EV Diff'}</span><br></br>

            </div> : window.innerWidth >= 768 ? <div className="dropdown-content-game-detail-tablet">
                <span>Games Played: {playerData !== undefined ? NumberFormatter(playerData.noOfGames) : 0}</span>
                <span>
                    P&L: {(playerData !== undefined && playerData.profitOrLoss > 0) ? "+" : ""}{playerData !== undefined ? NumberFormatter(playerData.profitOrLoss) : 0}
                </span>
                <span>Rake: {playerData !== undefined ? NumberFormatter(playerData.totalRake) : 0}</span>
                <span>Win Rate: {playerData !== undefined ? NumberFormatter(playerData.winRate) : 'winRate'} </span>
                <span>EV: {playerData !== undefined ? NumberFormatter(playerData.ev) : 'ev'}</span>
                <span>EV Diff: {playerData !== undefined ? NumberFormatter(playerData.evDiff) : 'EV Diff'}</span>

            </div> : ''}
            <button className='pw-clickmore-no-select-mobile' style={{ marginTop: window.innerWidth>=768?'4.5px':'-5px',marginRight:'5px' }} onClick={() => enableComponent('playerMenuEnable')}><i className="fa fa-lg fa-ellipsis-h"></i></button>
        </div>
    </nav>
}
const MobileStatsView = (props) => {
    const { enableComponent, openDialogBox, reportCard,bussinessOwnerStatus } = props;
    return <div className="pw-filter-mobile-view">
       <span className="pw-filter-mobile-setting-span"> Player Settings</span> <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={() => enableComponent('playerMenuEnable')}></i>
            <div style={{paddingTop:'2rem'}} >
                {/* {this.state.bussinessOwnerStatus ? <span className="pw-player-mobile-settings-2" onClick={this.roleUpdateModal}>Change Role</span> : ''} */}
                <span className="pw-player-mobile-settings-2" onClick={e => enableComponent('filterEnable', false)}>Filter</span>
                <span className="pw-player-mobile-settings-2" onClick={(e) => openDialogBox('enableStats', 'statsUpdate',true)} >Enable Stats</span>
                <span className="pw-player-mobile-settings-2" onClick={(e) => openDialogBox('disableStats', 'statsUpdate',true)}>Disable Stats</span>
                <span className="pw-player-mobile-settings-2"
                 data-toggle="modal"
                    data-target="#downloadModal" 
                    onClick={(e)=>{
                        e.preventDefault();
                        props.openPopUp();
                        props.trackDownloadPlayerHandHistory(props.playerData ? props.playerData.playerName : "N/A");
                    }}
                     >Download Hands</span>
                <span className="pw-player-mobile-settings-2" onClick={reportCard} data-e2e="Open Report Card">Open Report Card</span>
                <span className="pw-player-mobile-settings-2" onClick={e => openDialogBox('assingPlayer', 'assingPlayer',true)}>Assign Player</span>
                {bussinessOwnerStatus ? <span className="pw-player-mobile-settings-2" onClick={e => openDialogBox('deletePlayer', 'deletePlayer',true)}>Remove From Team</span> : ''}
            </div>
    
    </div>
}

const MobileDataView = (props) => {
    const { playerStats, NumberFormatter,isPlayerStatsAvailable, handleReplayer,onVisibilityChange } = props;
    return <div style={{ paddingTop: '10px', backgroundColor: 'white' }}>

    <div style={{ height: '20px' }}>

    </div>
    {playerStats.map((item, key) => {

        return (

            <div className='pw-team-div-mobile'>
                <div className='pw-team-details-mobile'>
                    <div className="pw-mobile-cards">
                        {item.dealtToCards}
                    </div>
                    <div className="pw-mobile-stat-details">
                        <span className={item.profitOrLoss > 0 ? "pokerwatch-mobile-profit-loss" : "pokerwatch-mobile-profit-loss-ve"}>{item.profitOrLoss > 0 ? "+" : ""}{NumberFormatter(item.profitOrLoss)}</span>
                        <span>{item.lastHandPlayer.split(" ")[1].replace(/[()]/g, "")} {item.lastHandPlayer.split(" ")[0]}  </span>
                        <span>#{item.gameNo}</span>
                    </div>
                    <div className="pw-mobile-replayer">
                        <i className="fa fa-2x fa-play-circle user-play-circle" onClick={e => handleReplayer(e, item)}></i>
                    </div>


                </div>
                
            </div>
        )
    })}
    <VisibilitySensor onChange={(isVisible) => onVisibilityChange(isVisible, 'player')} scrollCheck={true}>
                                <div className='pokerwatch-team-loading'>
                                    {isPlayerStatsAvailable ? <i className="fa fa-sync fa-lg fa-spin"></i> : ''}
                                </div>
                            </VisibilitySensor>
</div>
}
const PlayerMobileView = (props) => {
    const { playerStats, filterEnable,  playerData, playerMenuEnable,dialogContent } = props;
    //console.log('playerStats', playerStats, playerData,filterEnable);
    return (
        <div>
            
             
            {playerMenuEnable && !filterEnable ?<MobileStatsView {...props}></MobileStatsView>:filterEnable ? <FilterGrid {...props}></FilterGrid>:
            dialogContent && dialogContent.isDialogOpen && dialogContent.dataType !== 'downloadModal'  ?<CustomisedDiv {...props}>
        </CustomisedDiv>:<div><MobileHeaderView {...props}></MobileHeaderView>
            <MobileDataView {...props}></MobileDataView></div>}
            
           
          
           
            
        </div>)
}
class PokerwatchPlayerBody extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            pwTeamBody: props.data,
            dialogContent: { 'isDialogOpen': false },
            pokerwatchConfigObj: { ...props }
        };
    }

    handleReplayer = (e, item) => {
        const { pokerwatchConfigObj } = this.state
       // let m =item.time).utcOffset(0);
       // m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        //m.toISOString();
        let data = {
            gameNo: item.gameNo,
            gameType: item.gameType,
            partitionDate: item.time,
            playerName: pokerwatchConfigObj.playerData.playerName,
            players_alias: pokerwatchConfigObj.playerData.playerName,
            selectedFromDate: pokerwatchConfigObj['selectedFromDate'],
            selectedToDate: pokerwatchConfigObj['selectedToDate']
        };

        let track = {}
        track.hit_page = 'TeamDetail';
        track.hit_type = 'TeamPlayerReplayHand';
        track.hit_attribute1 = pokerwatchConfigObj.teamData.name || pokerwatchConfigObj.teamData.teamName;
        track.hit_attribute2 = pokerwatchConfigObj.currentSubTeam && pokerwatchConfigObj.currentSubTeam != "" ? pokerwatchConfigObj.currentSubTeam : "All Teams";
        track.hit_attribute3 = data.playerName;
        track.hit_attribute4 = data.gameNo;
        saveActivity(track);
        
        localStorage.setItem('handleReplayerData', JSON.stringify(data));
        window.open('/pokerwatchreplayer', '_blank');
        this.setState({
            gameDetails: false
        })
    }

    openPopUp = () =>{
        let track = {}
        track.hit_page = 'ExportHandsPopup';
        track.hit_type = 'OpenModal';
        track.hit_player = "admin";
        saveActivity(track);
      }

    componentDidMount() {

        const { pokerwatchConfigObj } = this.state;
        //console.log('pokerwatchConfigObj', pokerwatchConfigObj);
        pokerwatchConfigObj['openDialogBox'] = this.openDialogBox;
        //console.log('this.props', this.props);
        this.setState({
            pokerwatchConfigObj
        })
    }
    //     componentWillUnmount = () => {
    //         this.props.handleTeamAndPlayer();
    //   }
    render() {
        const { filterEnable, onVisibilityChange,position, isPlayerStatsAvailable, subTeam, playerStats, playerData, handlePlayerSort, bussinessOwnerStatus,  routeChange } = this.props;
        let handleSort = handlePlayerSort;
        //console.log('playerData', playerData);
        const headers = [
            { label: 'Game Number', id: 'gameNo', style: { padding: '0px', width: '155px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'Time', id: 'lastHandPlayer', style: { padding: '0px', width: '155px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'Stake Level', id: 'stakeLevel', style: { padding: '0px', width: '155px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'Win Rate', id: 'winRate', style: { padding: '0px', width: '100px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'EV', id: 'ev', style: { padding: '0px', width: '70px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'EV Win Rate', id: 'evWinRate', style: { padding: '0px', width: '120px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'EV Diff', id: 'evDiff', style: { padding: '0px', width: '100x' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'P&L', id: 'profitOrLoss', style: { padding: '0px', width: '100px' }, sortEnabled: true, handleSort, sortOrder: 'asc' },
            { label: 'Hole Cards', id: 'dealtToCards', style: { padding: '0px', width: '132px' } },
            { label: '', id: 'replayer', style: { padding: '0px' }, onClick: this.handleReplayer },
        ]

        let tableStyle = {
            thead: {
                height: '43px',
                background: '#F6F6F6',
                position:'sticky',
                top:'18rem'
                // border: '1px solid #E8E8E8',
                // borderLeft: '0px',
                // borderRight: '0px',
               
            },
            tbody: {
                height: '72px',
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 1px 0px',

            },
            root: {
                width: '100%',
                marginTop: '23px',
                // overflowX: 'auto',
                paddingLeft: '0px !important',
                paddingRight:'0px !important',
                fontFamily: 'Roboto Medium',
                boxShadow: '0px 0px 0px 0px',
                position:'sticky',
                top:'18rem'
            },
            headerCell:{
                paddingLeft:'15px',
                width:'0px',
                position:'sticky',
                top:'18rem',
                zIndexndex: '150',
                background: '#F6F6F6',
                border: '1px solid #E8E8E8',
                borderLeft: '0px',
                borderRight: '0px',
                zIndex:'150'
            },

            cell: {
                padding: '0px',
                fontSize: '16px',
                color: '#000000',
                fontFamily: 'Roboto-Medium'

            }
        }
        //console.log('subTeam', subTeam);
        // let tableStyle = {
        //     thead: {
        //         background: '#F6F6F6',
        //         height: '42px',
        //         border: '1px solid #E8E8E8',
        //         borderLeft: '0px',
        //         borderRight: '0px',
        //         position: 'sticky',
        //         top: '18.5rem'
        //     },
        //     tbody: {
        //         height: '72px',
        //         boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 1px 0px',

        //     },
        //     root: {
        //         width: '100%',
        //         marginTop: '0rem',
        //         // overflowX: 'auto',
        //         fontFamily: 'Open Sans SemiBold',
        //         boxShadow: '0px 0px 0px 0px',
        //         paddingLeft: '8px',
        //         position: 'sticky',
        //         top: '18.5rem'
        //     },
        //     table: {
        //         width: '124rem'
        //     },

        //     headerCell: {
        //         background: '#F6F6F6',
        //         fontFamily: 'Roboto',
        //         fontSize: '12px',
        //         width: '13rem',
        //         padding: '0px',
        //         textAlign: 'center',
        //         position: 'sticky',
        //         top: '18.5rem'
        //     },
        //     cell: {
        //         padding: '0px',
        //         fontSize: '15px',
        //         color: '#000000',
        //         fontFamily: "Roboto",
        //         fontWeight: 'normal',
        //         width: '22rem',
        //         textAlign: 'center'
        //     }
        // }
        if(filterEnable && playerStats && playerStats.length>0 ) {
            // if(currentSubTeam) {
            //  tableStyle['root']['top'] = '48.9rem';
            //  tableStyle['headerCell']['top']='47.9rem';
            // }
             tableStyle['root']['top']='29.7rem';
             tableStyle['headerCell']['top']='29.7rem';
             
             tableStyle['root']['position']=position?'inherit':'sticky'
             tableStyle['headerCell']['position']=position?'inherit':'sticky'
            
             
         }
        let teamTableDetails = <DataTable showCheckBox={false} showCheckBoxAll={false} headers={headers} rows={playerStats ? playerStats : []} styles={tableStyle} />
        return <MediaQuery minWidth={1025}>
            {(matches) => {
                if (matches) {
                    return <div>
                        <DownloadHandHistory accountName={playerData.playerName} />
                        {bussinessOwnerStatus ? <div style={{ position: 'fixed', top: '0rem', zIndex: 1300 }} ><button style={{ width: '20rem', background: 'transparent', border: '0px', height: '5rem' }} onClick={() => routeChange('/pokerwatch')}></button></div> : ''}
                            <nav className="navbar-fixed-top fixed-top-2" style={{ boxShadow: '0px 0px 0px 0px' }}>
                                <HeaderDetails {...this.props} pokerwatchConfigObj={this.state.pokerwatchConfigObj} openPopUp={this.openPopUp}></HeaderDetails>
                            </nav>
                            {filterEnable ? <FilterGrid {...this.props} ></FilterGrid> : ''}
                        <div className='container-fluid' style={{ marginTop:filterEnable?position?'-3rem': playerStats && playerStats.length>0?'24.8rem':'22rem': '11rem', position:playerStats && playerStats.length>0?position?'inherit':'sticky':'fixed',width:'1209px',marginLeft: '0rem' }}> {teamTableDetails}
                            <VisibilitySensor onChange={(isVisible) => onVisibilityChange(isVisible, 'player')} scrollCheck={true}>
                                <div className='pokerwatch-team-loading'>
                                    {isPlayerStatsAvailable ? <i className="fa fa-sync fa-lg fa-spin"></i> : ''}
                                </div>
                            </VisibilitySensor>
                        </div>
                    </div>
                }
                else {
                    return <PlayerMobileView {...this.props} openPopUp={this.openPopUp} handleReplayer={this.handleReplayer} ></PlayerMobileView>
                }
            }}
        </MediaQuery>

    }
}

export default PokerwatchPlayerBody;


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/Pokerwatch-player-body.js
 **/